import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 *
 */
class ProductBundleServices {
  /**
     *
     * @param {*} productSkuId
     * @param {*} searchKeyword
     * @param {*} tenantDepartmentId
     * @param {*} viewType
     * @returns
     */
     getProductBundle = async (productSkuId, searchKeyword, tenantDepartmentId, viewType) => {
       let url = `${Constants.PRODUCT_BUNDLE}?`;
       if (productSkuId) url += `product_sku_id=${productSkuId}&`;
       if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
       if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
       if (viewType) url += `view_type=${viewType}&`;
       const orgProductBundle = await Helpers.get({ url });
       return orgProductBundle;
     }

     /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     createProductBundle = async (payload) => {
       const addedProduct = await Helpers.post({
         url: Constants.PRODUCT_BUNDLE,
         data: payload,
       });
       return addedProduct;
     }

     /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     updateProductBundle = async (payload) => {
       const addedProduct = await Helpers.post({
         url: Constants.PRODUCT_BUNDLE,
         data: payload,
       });
       return addedProduct;
     }

     /**
      * @param orgId
      * @param type
      * @param bulkPoId
      * @return {Promise<*>}
      */
  getProductBundleById = async (orgId, bulkPOType, bulkPoId) => {
    let url = `${Constants.PRODUCT_BUNDLE}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (bulkPOType) url += `type=${bulkPOType}&`;
    if (bulkPoId) url += `blanket_po_id=${bulkPoId}&`;

    const selectedProductBundle = await Helpers.get({ url });
    return selectedProductBundle;
  }
}
export default new ProductBundleServices();
